class SysTem {
  constructor() { }
  setTenant(value) {
    sessionStorage["tenant_code"] = value;
  }
  getTenant() {
    return sessionStorage["tenant_code"];
  }
  removeTenant() {
    return sessionStorage.removeItem("tenant_code");
  }
  setTenantPlat(value) {
    sessionStorage["tenantPlat"] = value;
  }
  getTenantPlat() {
    return sessionStorage["tenantPlat"];
  }
  removeTenantPlat() {
    return sessionStorage.removeItem("tenantPlat");
  }
  setMenu(list) {
    sessionStorage["menu"] = JSON.stringify(list);
  }
  getMenu() {
    return sessionStorage["menu"];
  }
  removeMenu() {
    sessionStorage.removeItem("menu");
  }
  setTenantList(list) {
    sessionStorage["tenantList"] = JSON.stringify(list);
  }
  getTenantList() {
    return sessionStorage["tenantList"];
  }
  removeTenantList() {
    sessionStorage.removeItem("tenantList");
  }
  setUserInfo(obj) {
    sessionStorage["user_info"] = JSON.stringify(obj);
  }
  getUserInfo() {
    return sessionStorage["user_info"];
  }
  removeUserInfo() {
    sessionStorage.removeItem("user_info");
  }
  setLoginOidcStatus(num) {
    sessionStorage["login-oidc-status"] = num;
  }
  getLoginOidcStatus() {
    return sessionStorage["login-oidc-status"];
  }
  removeLoginOidcStatus() {
    sessionStorage.removeItem("login-oidc-status");
  }
  setIdToken(str) {
    sessionStorage["id-token"] = str;
  }
  getIdToken() {
    return sessionStorage["id-token"];
  }
  removeIdToken() {
    sessionStorage.removeItem("id-token");
  }
  setToken(str) {
    sessionStorage["token"] = str;
  }
  getToken() {
    return sessionStorage["token"];
  }
  removeToken() {
    sessionStorage.removeItem("token");
  }
  cleanSystemInfo() {
    [
      "token",
      "id-token",
      "login-oidc-status",
      "user_info",
      "menu",
      "tenantList",
      "partitionInfo"
    ].forEach(key => {
      sessionStorage.removeItem(key);
    });
  }
  setApp(value) {
    sessionStorage["app"] = value;
  }
  getApp() {
    return sessionStorage["app"];
  }
  removeApp() {
    sessionStorage.removeItem("app");
  }
  setCompany(value) {
    sessionStorage["company"] = value;
  }
  getCompany() {
    return sessionStorage["company"];
  }
  removeCompany() {
    sessionStorage.removeItem("company");
  }
  setExtensionParams(str) {
    sessionStorage["extensionParams"] = str;
  }
  getExtensionParams() {
    return sessionStorage["extensionParams"]
      ? JSON.parse(sessionStorage["extensionParams"])
      : {};
  }
  setPartitionInfo(str) {
    sessionStorage["partitionInfo"] = str;
  }
  getPartitionInfo() {
    return sessionStorage["partitionInfo"];
  }
  removePartitionInfo() {
    sessionStorage.removeItem("partitionInfo");
  }
  setBeOpenmenus(list) {
    sessionStorage["openmenus"] = list;
  }
  getBeOpenmenus() {
    return sessionStorage["openmenus"];
  }
  removeBeOpenmenus() {
    sessionStorage.removeItem("openmenus");
  }
  getUserName() {
    const user_info = this.getUserInfo() ? JSON.parse(this.getUserInfo()) : {}
    return user_info.username
  }

  removeExtensionParams() {
    sessionStorage.removeItem('extensionParams')
  }
  setMenuInfo(data) {
    sessionStorage['menu'] = data
  }
  getMenuInfo() {
    return sessionStorage["menu"]
      ? JSON.parse(sessionStorage["menu"])
      : []
  }
  removeMenuInfo() {
    sessionStorage.removeItem('menu')
  }
  setMenuSourceData(data) {
    sessionStorage['sourceMenuData'] = data
  }
  getMenuSourceData() {
    return sessionStorage["sourceMenuData"]
      ? JSON.parse(sessionStorage["sourceMenuData"])
      : []
  }
  removeMenuSourceData() {
    sessionStorage.removeItem('sourceMenuData')
  }
  setServerConfig(data) {
    sessionStorage['PROXY_URL_CONFIG'] = data
  }
  getServerConfig() {
    const str = sessionStorage['PROXY_URL_CONFIG']
    if (str) {
      return JSON.parse(str)
    } else {
      return {}
    }
  }
  removeServerConfig() {
    sessionStorage.removeItem('PROXY_URL_CONFIG')
  }
  setMenuParam(obj) {
    sessionStorage['menuParam'] = JSON.stringify(obj)
  }
  getMenuParam() {
    const str = sessionStorage['menuParam']
    return str ? JSON.parse(str) : {}
  }
  getItemCategory() {
    return sessionStorage['item_category'] || ''
  }
  setItemCategory(v){
    sessionStorage['item_category']=v
  }
  initUrlInfo() {
    try {
      const href = location.href
      // 找到第一个? 问号后面的是问号参数
      const index = href.indexOf('?')
      const parmsStr = href.slice(index + 1)
      const parmsStrList = parmsStr.split('&')
      const obj = {}
      parmsStrList.forEach(item => {
        const [key, label] = item.split('=')
        obj[key] = label
      })
      if (obj.loginMethod) {
        sessionStorage['loginMethod'] = obj.loginMethod
      }
      // 筛选菜单用的
      if (obj.item_category) {
        setItemCategory(obj.item_category)
      }
      this.setMenuParam(obj)
    } catch (error) {
      console.error('url解析初始化出错', error)
    }
  }
  getTenantId() {
    const user_info = this.getUserInfo() ? JSON.parse(this.getUserInfo()) : {}
    return user_info.tenant_id
  }
}

export default new SysTem();



// WEBPACK FOOTER //
// ./src/utils/systemInfo.js